import React, {
  useState,
  useMemo,
  useCallback
} from 'react'
import { useHistory } from 'react-router'
import {
  Card,
  CardHeader
} from 'reactstrap'
import {
  TitlePage,
  RedirectButton
} from 'components/atoms'
import { DataTable } from 'components/organisms'
import { productCollectionTableColumns } from 'domains/product-collection/molecules'
import ProductCollectionsApiV2 from 'api/v2/admins/product-collections-api-v2'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const ProductCollectionListPage = ({ pageUtils }) => {

  const [ collections, setCollections ] = useState([])
  const [ pagination, setPagination ]   = useState({})
  const [ isLoading, setIsLoading ]     = useState(false)

  const history = useHistory()

  const handleFetchProductCollections = async (tableState) => {
    setIsLoading(true)
    await ProductCollectionsApiV2.get({ tableState })
      .then((response) => {
        const data = response.data.collection
        const meta = response.data.meta

        setCollections(data)
        setPagination(meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally( () => setIsLoading(false) )
  }

  // Goes to Collection detail Page when clicking on the row button
  const handleSelectRow = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname : `/app/products/collections/${id}`,
      state    : { name: datum.name, isStandalone: datum.is_standalone_page, url: datum.url }
    })
  }, [ history ])

  const columns = useMemo(() => productCollectionTableColumns({ handleSelectRow }), [ handleSelectRow ])

  return (
    <>
      <TitlePage mainTitle='Product Collections' />
      <Card>
        <CardHeader className='font-weight-bold'>
          Product Collection List
          <span className='float-right'>
            <RedirectButton
              color='success'
              text='Create New Product Collection'
              path='/app/products/collections/create'
            />
          </span>
        </CardHeader>
        <DataTable
          data={ collections }
          pagination={ pagination }
          columns={ columns }
          onFetchData={ handleFetchProductCollections }
          isLoading={ isLoading }
        />
      </Card>
    </>
  )
}

ProductCollectionListPage.propTypes    = propTypes
ProductCollectionListPage.defaultProps = defaultProps

export default ProductCollectionListPage
